import axios from "axios";
import authHeader from '../../../authheader'

const EFAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/FirmEfApplication";

const getViolation = (applicationId) => {
    return axios.get(`${EFAPPLICATIONURL}/violation`, { headers: authHeader(), params: { applicationId } });
}
const postViolation = (data) => {
    return axios.post(`${EFAPPLICATIONURL}/violation`, data, { headers: authHeader() });
}
export default {
    getViolation,
    postViolation
}